import { render } from "./Order.vue?vue&type=template&id=4c418070&scoped=true"
import script from "./Order.vue?vue&type=script&lang=ts"
export * from "./Order.vue?vue&type=script&lang=ts"

import "./Order.vue?vue&type=style&index=0&id=4c418070&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c418070"

export default script